import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { AboutNotifier } from './about-notifier';
import { AboutState } from './about-state';

@Injectable()
export class AboutProvider extends BaseProvider<AboutNotifier, AboutState> {
  constructor() {
    super(AboutNotifier);
  }
}
